import React, { createContext, useReducer } from 'react'

import { Classroom as ClassroomConstants } from '@constants'
import { useClassroomEnv } from '@components/ClassroomEnv'

export const ClassroomStateContext = createContext()
export const ClassroomDispatchContext = createContext()

const reducer = (state, action) => {
  switch (action.type) {
    case 'set_error':
      return { ...state, error: action.payload }
    case 'set_step':
      return { ...state, step: action.payload }
    case 'set_background':
      return { ...state, background: action.payload }
    case 'set_is_background_loading':
      return { ...state, isBackgroundLoading: action.payload }
    case 'set_notifications':
      return {
        ...state,
        notifications: { ...state.notifications, ...action.payload }
      }
    case 'set_panels':
      return { ...state, panels: action.payload }
    case 'toggle_sidebar': {
      const isOpen = state.sidebarPanel === action.payload ? false : true
      return {
        ...state,
        isSidebarOpen: isOpen,
        sidebarPanel: isOpen ? action.payload : null // null | 'conversation' | 'member_controls' | 'standard_controls'
      }
    }
    case 'open_fullscreen_modal':
      return { ...state, isFullscreenModalOpen: true }
    case 'close_fullscreen_modal':
      return { ...state, isFullscreenModalOpen: false }
    case 'open_screen_share_modal':
      return { ...state, isScreenShareModalOpen: true }
    case 'close_screen_share_modal':
      return { ...state, isScreenShareModalOpen: false }
    case 'open_invite_modal':
      return { ...state, isInviteModalOpen: true }
    case 'close_invite_modal':
      return { ...state, isInviteModalOpen: false }
    case 'data_fetched': {
      const dataWasAlreadyFullyFetched =
        state.data.classroom && state.data.files && state.data.memberControls
      const nextState = {
        ...state,
        data: {
          ...state.data,
          [action.payload]: true
        }
      }
      const dataIsFullyFetched =
        nextState.data.classroom &&
        nextState.data.files &&
        nextState.data.memberControls
      const proceedToOnboarding =
        dataIsFullyFetched && !dataWasAlreadyFullyFetched
      return {
        ...nextState,
        step: proceedToOnboarding
          ? ClassroomConstants.STEPS.ONBOARDING
          : state.step
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

export const ClassroomProvider = ({ children }) => {
  const { id } = useClassroomEnv()

  const [state, dispatch] = useReducer(reducer, {
    error: null,
    step: ClassroomConstants.STEPS.FETCHING,
    isBackgroundLoading: false,
    background: 'default',
    notifications: { expiring: false },
    isFullscreenModalOpen: false,
    isScreenShareModalOpen: false,
    isInviteModalOpen: false,
    isSidebarOpen: false,
    sidebarPanel: null,
    panels: [],
    id,
    data: { classroom: false, files: false, memberControls: false }
  })

  return (
    <ClassroomStateContext.Provider value={state}>
      <ClassroomDispatchContext.Provider value={dispatch}>
        {children}
      </ClassroomDispatchContext.Provider>
    </ClassroomStateContext.Provider>
  )
}

export * from './ConversationContext'
export * from './ClassroomPermissionsContext'
